import { render, staticRenderFns } from "./FundingProjectsFilter.vue?vue&type=template&id=5325c90d&"
import script from "./FundingProjectsFilter.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports